<template>
  <div class="main">
    <div class="list-box">
      <div class="list" v-for="item in list" :key="item.id">
        <div class="img">
          <img :src="item.image" width="100%" alt="">
        </div>
        <div class="list-title clearfix">
          <span>{{item.title}}</span><span>{{item.time}}</span></div>
        <div class="list-introduce">{{item.introduce}}</div>
        <div class="btn" @click="goDetail(item.id)">查看详情</div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span :style="pageVal == 1 ? 'color:#a1a1a1;' : ''" @click="lastPage()">上一页</span>
      <span :style="pageVal >= maxPage ? 'color:#a1a1a1;' : ''" @click="nextPage()">下一页</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pageVal: 1,
      pageSize: 3,
      list: [],
      maxPage: 0
    }
  },
  methods: {
    lastPage () {
      if (this.pageVal > 1) {
        this.pageVal -= 1
        this.getList()
        // document.body.scrollTop = 0
        // document.documentElement.scrollTop = 0
      }
      // console.log(this.pageVal)
    },
    nextPage () {
      if (this.pageVal < this.maxPage) {
        this.pageVal += 1
        this.getList()
        // document.body.scrollTop = 0
        // document.documentElement.scrollTop = 0
      }
    },
    // 列表接口
    getList () {
      this.$http.post('/api/caucus/getList', {
        page: this.pageVal,
        pageSize:this.pageSize,
        noPaginate:1
      }).then( (res)=> {
        if(res.data.code === 0){
          this.$emit("banner", res.data.data.mobileBanner)
          this.list = res.data.data.list
          let total = res.data.data.total
          // console.log(Math.ceil(total / 3))
          this.maxPage = Math.ceil(total / 3)
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        }
      }).catch(function (error) {
          // console.log(error);
      });
    },
    // 跳转详情
    goDetail (id) {
      this.$router.push({ name: 'mDetail', query: { 'id': id, 'type': 'mCaucus' } })
    }
  },
  created () {
    this.getList()
  }
}
</script>
<style scoped>
.main {

}
.list-box {
  /* width: 100%; */
  margin: 0 0.35rem;
}
.list {
  width: 100%;
  height: 6rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  box-shadow: 0 3px 8px 0px #ccc;
  overflow: hidden;
}
.img {
  width: 100%;
  height: 3.3rem;
  overflow: hidden;
}
.list-title {
  margin: 0.2rem 0.3rem;
}
.list-title span:first-child {
  float: left;
  font-size: 0.3rem;
  font-weight: 600;
  color: #404040;
}
.list-title span:last-child {
  float: right;
  font-size: 0.22rem;
  color: #b5b5b5;
}
.list-introduce {
  height: 0.67rem;
  font-size: 0.24rem;
  color: #737373;
  margin: 0.2rem 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
}
.btn {
  width: 2.5rem;
  height: 0.65rem;
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  line-height: 0.65rem;
  background-color: #fccb5e;
  border-radius: 0.6rem;
  margin: 0.2rem auto;
}
/* 分页 */
.pages {
  font-size: 0.28rem;
  color: #f7b209;
  font-weight: 600;
  text-align: center;
}
.pages span {
  margin: 0 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/mbPages/mCaucus.vue